import { EmpathizeState } from '../../../models';
import { EMPATHIZE_MUTATIONS_KEYS } from '../empathize.const';
import { EmpathizeMutation } from '../empathize.interfaces';

export class SetLoadingMutation implements EmpathizeMutation {
  mutations = {
    [EMPATHIZE_MUTATIONS_KEYS.setLoading]: (empathizeState: EmpathizeState, loading: boolean) => {
      empathizeState.loading = loading;
    }
  };
}
